import React from 'react';
import PropTypes from 'prop-types';

import ModalContent from './components/ModalContent/ModalContent';
import ModalPortal from './components/ModalPortal/ModalPortal';

const Modal = ({
  isOpen, onModalClose, children, ariaId,
}) => isOpen && (
<ModalPortal>
  <ModalContent
    onModalClose={onModalClose}
    ariaId={ariaId}
  >
    {children}
  </ModalContent>
</ModalPortal>
);

Modal.defaultProps = {
  isOpen: false,
};

Modal.propTypes = {
  ariaId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  onModalClose: PropTypes.func.isRequired,
};

export default Modal;
